/**
 * DeductCreditsModal - Modal for deducting credits from a user
 */
export default function DeductCreditsModal({
  show,
  onClose,
  deductAmount,
  setDeductAmount,
  deductReason,
  setDeductReason,
  onDeduct,
  loading,
  isBulk = false,
  selectedCount = 0,
}) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[60] flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-xl max-w-md w-full p-6 space-y-4">
        <h3 className="text-xl font-bold text-foreground">
          {isBulk ? `Deduct Credits from ${selectedCount} Users` : "Deduct Credits"}
        </h3>
        <input
          type="number"
          placeholder={isBulk ? "Amount per user" : "Amount"}
          value={deductAmount}
          onChange={(e) => setDeductAmount(e.target.value)}
          className="w-full px-4 py-2 bg-muted border border-border rounded-lg text-foreground placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <input
          type="text"
          placeholder="Reason"
          value={deductReason}
          onChange={(e) => setDeductReason(e.target.value)}
          className="w-full px-4 py-2 bg-muted border border-border rounded-lg text-foreground placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-primary"
        />
        {isBulk && (
          <div className="bg-orange-500/10 border border-orange-500/20 rounded-lg p-3">
            <p className="text-orange-400 text-sm">
              <strong>{deductAmount || 0}</strong> credits will be deducted from each user
            </p>
          </div>
        )}
        <div className="flex gap-3">
          <button
            onClick={onDeduct}
            disabled={loading}
            className="flex-1 px-4 py-2 bg-orange-600 hover:bg-orange-700 disabled:opacity-50 text-foreground rounded-lg transition"
          >
            {loading ? "Processing..." : isBulk ? "Deduct from All" : "Deduct"}
          </button>
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 bg-muted hover:bg-slate-600 text-foreground rounded-lg transition"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
